export default {
    renderPriceDetails: 'render-price-details'
};
